import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Row,
  CardBody,
  Col,
  FormGroup,
  Label,
  FormText,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Alert,
  Form,
} from "reactstrap";
import { useFetch } from "../../utils/fetchHook";
import { getCookie } from "../../jwt/_helpers/cookie";
import Select from "react-select";
import { Trans, useTranslation } from "react-i18next";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const OrderCredits = () => {

  const token = getCookie("token");

  const { t, i18n } = useTranslation();

  const creditsAmountOps = [
    { label: t("credits.view.form.options.quantity.1Credit"), value: 1 },
    { label: t("credits.view.form.options.quantity.2Credits"), value: 2 },
    { label: t("credits.view.form.options.quantity.3Credits"), value: 3 },
    { label: t("credits.view.form.options.quantity.4Credits"), value: 4 },
    { label: t("credits.view.form.options.quantity.5Credits"), value: 5 },
    { label: t("credits.view.form.options.quantity.10Credits"), value: 10 },
    { label: t("credits.view.form.options.quantity.15Credits"), value: 15 },
    { label: t("credits.view.form.options.quantity.20Credits"), value: 20 },
    { label: t("credits.view.form.options.quantity.25Credits"), value: 25 },
    { label: t("credits.view.form.options.quantity.30Credits"), value: 30 },
    { label: t("credits.view.form.options.quantity.35Credits"), value: 35 },
    { label: t("credits.view.form.options.quantity.40Credits"), value: 40 },
    { label: t("credits.view.form.options.quantity.45Credits"), value: 45 },
    { label: t("credits.view.form.options.quantity.50Credits"), value: 50 },
    { label: t("credits.view.form.options.quantity.75Credits"), value: 75 },
    { label: t("credits.view.form.options.quantity.100Credits"), value: 100 },
  ];

  const options = {
    method: "POST",
    mode: 'cors',
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": X_API_KEY,
      "Content-Type": "application/json"
    }
  };

  const currentDate = (new Date());
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const [openModal, setToggleModal] = useState(false);
  const [errorPut, setError] = useState(false);
  const [forceUpdate, setForce] = useState(1);
  const [checkoutLink, setCheckoutLink] = useState("");
  const [sessionId, setSessionId] = useState("");

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [apiData, error, loading] = useFetch("GET", `user-payment/list/`, token, false, forceUpdate);

  const [paymentMethodValid, setPaymentMethodValid] = useState(true);

  const [creditsAmountTab, setCreditsAmountTab] = useState({
    label: t("credits.view.form.options.quantity.selectQuantity"),
    value: "",
  });

  useEffect(() => {
    if (creditsAmountTab.value === "") {
      let newCreditsAmountTab = {
        label: t("credits.view.form.options.quantity.selectQuantity"),
        value: "",
      };
      setCreditsAmountTab(newCreditsAmountTab);
    }
  }, [i18n.language]);

  useEffect(() => {
    if (apiData) {
      setPaymentMethods(apiData);

      let filteredData = apiData.filter(function (el) {
        return el.is_default === true;
      });

      if(filteredData.length === 1)
      {
        let defaultPaymentMethod = filteredData[0];
        let expiryYear = parseInt(defaultPaymentMethod.exp_year);
        let expiryMonth = parseInt(defaultPaymentMethod.exp_month);
        let cardValid = true;

        if(expiryYear===currentYear && expiryMonth<currentMonth)
        {
          cardValid = false;
        }
        else if (defaultPaymentMethod.status==="expired"){
          cardValid = false;
        }
        setPaymentMethodValid(cardValid);
      }
    }
  }, [apiData]);


  const validateFields = () => {
    let validationErrors = 0;
    if (creditsAmountTab.value==="") {
      document.getElementById("err_credits_quantity").style.display = "block";
      validationErrors = validationErrors+1;
    }
    return validationErrors;
  }

  const handleSubmit = () => {

    const validationErrors = validateFields();

    if (validationErrors!==0) {
      return false;
    }

    else {

      let orderData = {
        "quantity": creditsAmountTab.value,
      };

      axios
      .post(`${API_URL}create-checkout-session/`, orderData, options).then(function(response) {
        if (response.status === 200) {
          let response_data = response.data;
          if (response_data.url)
          {
            setCheckoutLink(response_data.url);
            setSessionId(response_data.session_id);
            setToggleModal(true);
          }
        } 
        else {
          setError(true);
        }
      }).catch(function (error) {
        if (error.response) {
          if(error.response.status === 400)
          {
            let error_data = error.response.data;
            if(error_data.error)
            {
              console.log(error_data.error);
              setError(true);
            }
          }
        } else if (error.request) {
          setError(true);
        } else {
          setError(true);
        }
    
      });
    }

  }

  return (
    <div>
      {
        paymentMethods.length<=0 && (
          <Alert color="danger">
            <b>
              <Trans i18nKey="credits.view.form.message.paymentMethodRequired">
                Please add a <a href="/payment-methods">payment method</a> in order to place order for credits.
              </Trans>
            </b>
          </Alert>
        )
      }
      {
        !paymentMethodValid && (
          <Alert color="danger">
            <b>
              <Trans i18nKey="credits.view.form.message.paymentMethodExpired">
                You can not place order for credits as your default <a href="/payment-methods">payment method</a> has expired, please set a valid payment method as default in order to place order for credits.
              </Trans>
            </b>
          </Alert>
        )
      }
      <Row>
        <Col sm={12}>
          <Card>
            <CardBody>
              <h3>{t("credits.view.form.title")}</h3>

              <Form id="orderCreditsForm">

                <FormGroup>
                  <Label>{t("credits.view.form.label.quantity")}</Label>
                  <Select
                      components={{ IndicatorSeparator: () => null }}
                      closeMenuOnSelect={true}
                      className="artistType"
                      name="quantity"
                      options={creditsAmountOps}
                      value={creditsAmountTab}
                      placeholder={t("credits.view.form.placeholder.quantity")}
                      onChange={(e) => {
                        document.getElementById("err_credits_quantity").style.display = "none";
                        setCreditsAmountTab(e);
                      }}
                  />
                  <FormText color="muted">
                    {t("credits.view.form.help_text.quantity")}
                  </FormText>
                  <div style={{width: '100%', display: 'flex', marginTop: '5px'}}>
                    <div className="fv-help-block" style={{ display: 'none'}} id={"err_credits_quantity"}>{t("credits.view.form.message.quantityRequired")}</div>
                  </div>
                </FormGroup>

                <Button className="btn btn-outline-success pull-right" color="success" onClick={handleSubmit} disabled={paymentMethods.length<=0 || !paymentMethodValid}>
                  {t("credits.view.form.button.placeOrder")}
                </Button>
              </Form>

              <div style={{ paddingTop: "24px" }}>
                {errorPut && (
                  <Alert color="danger">
                    {t("credits.view.form.message.error")}
                  </Alert>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {openModal && (
        <Modal isOpen={openModal} centered={true}>
        <ModalHeader>{t("credits.view.modal.header")}</ModalHeader>
        <ModalBody>
            {t("credits.view.modal.body.message", {credits: creditsAmountTab.value})}

            <br/><br/>{t("credits.view.modal.body.confirmationMessage")}
            
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => {
            axios.post(`${API_URL}expire-checkout-session/`, {"session_id": sessionId }, options);
            setToggleModal(false);
          }}
          >
            {t("credits.view.modal.button.cancel")}
          </Button>
          <a href={`${checkoutLink}`} className="btn btn-md btn-success" rel="noopener noreferrer">{t("credits.view.modal.button.checkout")}</a>
        </ModalFooter>
      </Modal>
      )}
    </div>
  );
};

export default OrderCredits;
